// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  NewQuoteSuspendedOrder,
  type QuoteSuspendedOrder,
  type QuoteSuspendedOrderWireFormat,
} from '../QuoteSuspendedOrder/QuoteSuspendedOrder';

export class ActualsSuspendedQuote {
  readonly quoteId: string;
  readonly quoteNumber: string;
  readonly name: string | null;
  readonly orders: QuoteSuspendedOrder[];

  constructor(data: { [key: string]: any } = {}) {
    this.quoteId = data.quoteId === undefined ? NIL_UUID : data.quoteId;
    this.quoteNumber = data.quoteNumber === undefined ? '' : data.quoteNumber;
    this.name = data.name === undefined ? null : data.name;
    this.orders = (data.orders ?? []).map((orders: any) => NewQuoteSuspendedOrder(orders));
  }

  static zero(): ActualsSuspendedQuote {
    const zeroValues: ExcludeMethodsDeep<ActualsSuspendedQuote> = {
      quoteId: NIL_UUID,
      quoteNumber: '',
      name: null,
      orders: [],
    };
    return new ActualsSuspendedQuote(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ActualsSuspendedQuoteWireFormat = {
  quoteId: string;
  quoteNumber: string;
  name: string | null;
  orders: QuoteSuspendedOrderWireFormat[];
};

type NewActualsSuspendedQuoteProps = PartialDeep<
  ActualsSuspendedQuote,
  { recurseIntoArrays: true }
>;
export const NewActualsSuspendedQuote: (
  props: NewActualsSuspendedQuoteProps,
) => ActualsSuspendedQuote = (props) => new ActualsSuspendedQuote(props);

type NewActualsSuspendedQuoteFromWireFormatProps = PartialDeep<
  ActualsSuspendedQuoteWireFormat,
  { recurseIntoArrays: true }
>;
export const NewActualsSuspendedQuoteFromWireFormat: (
  props: NewActualsSuspendedQuoteFromWireFormatProps,
) => ActualsSuspendedQuote = (props) => new ActualsSuspendedQuote(props);
